import { render, staticRenderFns } from "./SearchCon.vue?vue&type=template&id=28c6ba80"
import script from "./SearchCon.vue?vue&type=script&lang=js"
export * from "./SearchCon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports